import type { ReactElement } from 'react';

/**
 * Знак кабинета — как в панели доставки Zenta: квадрат цвета акцента со значком
 * грузовика и название продукта рядом. Значок рисуется текущим цветом, поэтому без
 * отдельных версий под тёмную тему.
 */
export function Logo({
  name,
  size = 'var(--mark)',
}: {
  readonly name: string;
  readonly size?: string;
}): ReactElement {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--sp-2)',
        fontSize: 'var(--fs-lg)',
        fontWeight: 'var(--fw-bold)',
        color: 'var(--text)',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        aria-hidden
        style={{
          width: size,
          height: size,
          borderRadius: 'var(--r-sm)',
          background: 'var(--accent)',
          color: 'var(--text-on-accent)',
          display: 'grid',
          placeItems: 'center',
          flex: 'none',
        }}
      >
        <svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
          <path d="M15 18H9" />
          <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
          <circle cx="17" cy="18" r="2" />
          <circle cx="7" cy="18" r="2" />
        </svg>
      </span>
      {name}
    </span>
  );
}
